import React from 'react';
import styled from '@emotion/styled';
import LabelQuestion from './LabelQuestion';

const Wrapper = styled('div')`
  padding-left: 0;
  * {
    cursor: pointer !important;
  }
  .custom-control-label {
    &:before,
    &:after {
      left: 0;
    }
  }
`;

const Checkbox = (props) => {
  const {
    label,
    id,
    error,
    showValidation,
    inlineLayout,
    labelStyle = {},
    wrapperStyle = {},
    labelQuestion,
    testId,
    useRef,
    labelClass = false,
    inputClass = false,
    isDisabled = false,
  } = props;

  const passedProps = Object.assign({}, props);
  delete passedProps.labelStyle;
  delete passedProps.showValidation;

  if (label) {
    labelStyle.paddingLeft = '1.5rem';
  } else {
    wrapperStyle.width = '1.1rem';
  }

  return (
    <React.Fragment>
      <Wrapper
        className={
          'custom-control custom-checkbox ' + (inlineLayout ? 'custom-control-inline' : '')
        }
        style={wrapperStyle}
      >
        <input
          type="checkbox"
          className={`custom-control-input ${inputClass ? inputClass : ''}`}
          id={id}
          name={id}
          data-testid={testId}
          ref={useRef}
          disabled={isDisabled}
          {...passedProps}
        />
        <LabelQuestion
          label={label}
          labelClass={`custom-control-label ${labelClass ? labelClass : ''}`}
          htmlFor={id}
          style={labelStyle}
          question={labelQuestion}
        />
      </Wrapper>
      {error && Boolean(showValidation) && (
        <div
          className="invalid-feedback"
          style={{ display: 'block' }}
          data-testid={`${testId}--error`}
        >
          {error}
        </div>
      )}
    </React.Fragment>
  );
};

export default Checkbox;
